import { render, staticRenderFns } from "./TheFeatures.vue?vue&type=template&id=09f703db"
import script from "./TheFeatures.vue?vue&type=script&lang=js"
export * from "./TheFeatures.vue?vue&type=script&lang=js"
import style0 from "./TheFeatures.vue?vue&type=style&index=0&id=09f703db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports